import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/Layout/Layout'

import Login from '@/pages/Login/Login'
import LupaPassword from '@/pages/Login/LupaPassword'
import Register from '@/pages/Register/Register'
import AnalyticsPage from '@/pages/Dashboard/DashboardPengendalian'
import ChatPage from '@/pages/Chat/Chat'
import Verdok from '@/pages/Verdok/Verdok'
import ErrorPage from '@/pages/Error/Error'
import ErrorPage403 from '@/pages/Error/Error403'

// masterdata
import UserPage from '@/pages/User/User'
import JabatanPage from '@/pages/Master/Jabatan/Jabatan'

// laporan tahunan
import LaporanTahunanPage from '@/pages/LaporanTahunan/LaporanTahunan'
import formLaporanTahunanPage from '@/pages/LaporanTahunan/formLaporanTahunan'
import PenilaianLaporanTahunanPage from '@/pages/PenilaianLaporanTahunan/PenilaianLaporanTahunan'
import formVerifikasiLaporanPage from '@/pages/PenilaianLaporanTahunan/formVerifikasiLaporan'
import RekomendasiPenilaianPelaksanaan from '@/pages/RekomendasiPenilaianPelaksanaan/RekomendasiPenilaianPelaksanaan'
import RencanaAksiPusat from '@/pages/RencanaAksi/RencanaAksiPusat/RencanaAksiPusat'
import formRencanaAksiPusat from '@/pages/RencanaAksi/RencanaAksiPusat/formRencanaAksiPusat'
import formTambahRencanaAksiPusat from '@/pages/RencanaAksi/RencanaAksiPusat/formTambahRencanaAksi'
import RencanaAksiUpt from '@/pages/RencanaAksi/RencanaAksiUpt/RencanaAksiUpt'
import formRencanaAksiUpt from '@/pages/RencanaAksi/RencanaAksiUpt/formRencanaAksiUpt'
import formTambahRencanaAksiUpt from '@/pages/RencanaAksi/RencanaAksiUpt/formTambahRencanaAksi'
import PenilaianPelaksanaanPusat from '@/pages/PenilaianPelaksanaan/PenilaianPelaksanaanPusat/PenilaianPelaksanaanPusat'
import formPenilaianPelaksanaanPusat from '@/pages/PenilaianPelaksanaan/PenilaianPelaksanaanPusat/formPenilaianPelaksanaanPusat'
import PenilaianPelaksanaanUpt from '@/pages/PenilaianPelaksanaan/PenilaianPelaksanaanUpt/PenilaianPelaksanaanUpt'
import formPenilaianPelaksanaanUpt from '@/pages/PenilaianPelaksanaan/PenilaianPelaksanaanUpt/formPenilaianPelaksanaanUpt'
import PenilaianPelaksanaanPelakuUsaha from '@/pages/PenilaianPelaksanaan/PenilaianPelaksanaanPelakuUsaha/PenilaianPelaksanaanPelakuUsaha'
import formPenilaianPelaksanaanPelakuUsaha from '@/pages/PenilaianPelaksanaan/PenilaianPelaksanaanPelakuUsaha/formPenilaianPelaksanaanPelakuUsaha'

// Early Warning
import EarlyWarningBerusaha from './pages/Pemutakhiran/EarlyWarning/Berusaha.vue'
import EarlyWarningPemerintah from './pages/Pemutakhiran/EarlyWarning/Pemerintah.vue'
import EarlyWarningSwasta from './pages/Pemutakhiran/EarlyWarning/Swasta.vue'

// Pemutakhiran
import HabisMasaBerlaku from './pages/Pemutakhiran/HabisMasaBerlaku/HabisMasaBerlaku.vue'
import Perubahan from './pages/Pemutakhiran/Perubahan/Perubahan.vue'
import Pembatalan from './pages/Pemutakhiran/Pembatalan/Pembatalan.vue'
import Pencabutan from './pages/Pemutakhiran/Pencabutan/Pencabutan.vue'

// perizinan
import PerizinanDokumenPage from '@/pages/Perizinan/Dokumen/Dokumen'
import PerizinanDetailPage from '@/pages/Perizinan/Dokumen/Detail/Detail'
import NonberusahaPemerintah from '@/pages/Perizinan/Nonberusaha/PermohonanPemerintah'
import NonberusahaSwasta from '@/pages/Perizinan/Nonberusaha/PermohonanSwasta'
import PerizinanNonberusaha from '@/pages/Perizinan/Nonberusaha/Detail/Detail'

// Web ProfilPagee
import Profile from '@/pages/WebProfile/Profile/profile'
import Slider from '@/pages/WebProfile/Slider/slider'
import Approval from '@/pages/WebProfile/Approval/approval'
import About from '@/pages/WebProfile/About/about'
import Announcement from '@/pages/WebProfile/Announcement/announcement'
import AnnouncementDetail from '@/pages/WebProfile/Announcement/AnnouncementDetail'
import PressRelease from '@/pages/WebProfile/PressRelease/PressRelease'
import PressReleaseDetail from '@/pages/WebProfile/PressRelease/PressReleaseDetail'
import Report from '@/pages/WebProfile/Report/report'
import faq from '@/pages/WebProfile/Faq/faq'

import ProfilePage from '@/pages/Profile/Profile'
import PanduanPage from '@/pages/Panduan/Panduan'
import Tos from '@/pages/tos/tos'

import { canAccessUptScope, getUserUptScope, hasRole, isVerifikatorPusat } from './helper/helpernew'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/app/dashboard' },
    { path: '/app/master', redirect: '/app/master/user' },
    { path: '/app/web', redirect: '/app/web/profile' },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { redirectIfLogin: true },
    },
    {
      path: '/lupa-password',
      name: 'Lupa Password',
      component: LupaPassword,
      meta: { redirectIfLogin: true },
    },
    {
      path: '/privacy',
      name: 'ToS',
      component: Tos,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { redirectIfLogin: true },
    },
    {
      path: '/verdok',
      name: 'Verdok',
      component: Verdok,
    },
    {
      path: '/app',
      name: 'Layout',
      redirect: '/app/dashboard',
      component: Layout,
      children: [
        // main pages
        {
          path: 'dashboard',
          name: 'AnalyticsPage',
          component: AnalyticsPage,
          meta: { authRequired: true, role: ['Verifikator', 'Penilai', 'Pemrakarsa', 'Pejabat'] },
        },
        {
          path: 'chat',
          name: 'ChatPage',
          component: ChatPage,
          meta: { authRequired: true },
        },

        // laporan tahunan
        {
          path: 'laporan-tahunan',
          name: 'LaporanTahunan',
          component: LaporanTahunanPage,
          meta: { authRequired: true, role: ['Pemrakarsa'] },
        },
        {
          path: 'laporan-tahunan/form',
          name: 'FormLaporanTahunan',
          component: formLaporanTahunanPage,
          meta: { authRequired: true, role: ['Pemrakarsa'] },
        },
        {
          path: 'laporan-tahunan/tinjau',
          name: 'TinjauLaporanTahunanPemohon',
          component: formLaporanTahunanPage,
          meta: { authRequired: true, role: ['Verifikator', 'Penilai', 'Pemrakarsa'] },
        },
        {
          path: 'penilaian-laporan-tahunan',
          name: 'PenilaianLaporanTahunan',
          component: PenilaianLaporanTahunanPage,
          meta: { authRequired: true, role: ['Verifikator', 'Penilai', 'TimPengawas', 'Pejabat'] },
        },
        {
          path: 'penilaian-laporan-tahunan/verifikasi',
          name: 'VerifikasiLaporan',
          component: formVerifikasiLaporanPage,
          meta: { authRequired: true, role: ['Penilai'] },
        },
        {
          path: 'penilaian-laporan-tahunan/tinjau',
          name: 'TinjauLaporanTahunan',
          component: formVerifikasiLaporanPage,
          meta: { authRequired: true, role: ['Verifikator', 'Penilai', 'TimPengawas', 'Pejabat'] },
        },
        {
          path: 'rekomendasi-penilaian-pelaksanaan',
          name: 'RekomendasiPenilaianPelaksanaan',
          component: RekomendasiPenilaianPelaksanaan,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator'] },
        },
        {
          path: 'rencana-aksi',
          name: 'RencanaAksi',
          redirect: () => {
            const user = JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {}
            const scope = hasRole(user, 'Superuser') ? 'pusat' : getUserUptScope(user)
            return `/app/rencana-aksi/${scope}`
          },
          meta: { authRequired: true, role: ['Superuser', 'Verifikator', 'Penilai'] },
        },
        {
          path: 'rencana-aksi/pusat',
          name: 'RencanaAksiPusat',
          component: RencanaAksiPusat,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator', 'Penilai'], rencanaAksiScope: 'pusat' },
        },
        {
          path: 'rencana-aksi/pusat/form',
          name: 'TambahRencanaAksiPusat',
          component: formTambahRencanaAksiPusat,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator', 'Penilai'], rencanaAksiScope: 'pusat' },
        },
        {
          path: 'rencana-aksi/pusat/form/:id',
          name: 'FormRencanaAksiPusat',
          component: formRencanaAksiPusat,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator', 'Penilai'], rencanaAksiScope: 'pusat' },
        },
        {
          path: 'rencana-aksi/upt',
          name: 'RencanaAksiUpt',
          component: RencanaAksiUpt,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator'], rencanaAksiScope: 'upt' },
        },
        {
          path: 'rencana-aksi/upt/form',
          name: 'TambahRencanaAksiUpt',
          component: formTambahRencanaAksiUpt,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator'], rencanaAksiScope: 'upt' },
        },
        {
          path: 'rencana-aksi/upt/form/:id',
          name: 'FormRencanaAksiUpt',
          component: formRencanaAksiUpt,
          meta: { authRequired: true, role: ['Superuser', 'Verifikator'], rencanaAksiScope: 'upt' },
        },
        {
          path: 'penilaian-pelaksanaan',
          name: 'PenilaianPelaksanaan',
          redirect: () => {
            const user = JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {}
            const scope = hasRole(user, 'Superuser') ? 'pusat' : getUserUptScope(user)
            return `/app/penilaian-pelaksanaan/${scope}`
          },
          meta: { authRequired: true, role: ['Superuser', 'Penilai'] },
        },
        {
          path: 'penilaian-pelaksanaan/pusat',
          name: 'PenilaianPelaksanaanPusat',
          component: PenilaianPelaksanaanPusat,
          meta: { authRequired: true, role: ['Superuser', 'Penilai'], penilaianPelaksanaanScope: 'pusat' },
        },
        {
          path: 'penilaian-pelaksanaan/pusat/form',
          name: 'TambahPenilaianPelaksanaanPusat',
          component: formPenilaianPelaksanaanPusat,
          meta: { authRequired: true, role: ['Superuser', 'Penilai'], penilaianPelaksanaanScope: 'pusat' },
        },
        {
          path: 'penilaian-pelaksanaan/pusat/form/:id',
          name: 'FormPenilaianPelaksanaanPusat',
          component: formPenilaianPelaksanaanPusat,
          meta: { authRequired: true, role: ['Superuser', 'Penilai'], penilaianPelaksanaanScope: 'pusat' },
        },
        {
          path: 'penilaian-pelaksanaan/upt',
          name: 'PenilaianPelaksanaanUpt',
          component: PenilaianPelaksanaanUpt,
          meta: { authRequired: true, role: ['Superuser', 'Penilai'], penilaianPelaksanaanScope: 'upt' },
        },
        {
          path: 'penilaian-pelaksanaan/upt/form',
          name: 'TambahPenilaianPelaksanaanUpt',
          component: formPenilaianPelaksanaanUpt,
          meta: { authRequired: true, role: ['Superuser', 'Penilai'], penilaianPelaksanaanScope: 'upt' },
        },
        {
          path: 'penilaian-pelaksanaan/upt/form/:id',
          name: 'FormPenilaianPelaksanaanUpt',
          component: formPenilaianPelaksanaanUpt,
          meta: { authRequired: true, role: ['Superuser', 'Penilai'], penilaianPelaksanaanScope: 'upt' },
        },
        {
          path: 'penilaian-pelaksanaan/pelaku-usaha',
          name: 'PenilaianPelaksanaanPelakuUsaha',
          component: PenilaianPelaksanaanPelakuUsaha,
          meta: { authRequired: true, role: ['Pemrakarsa'] },
        },
        {
          path: 'penilaian-pelaksanaan/pelaku-usaha/form',
          name: 'FormPenilaianPelaksanaanPelakuUsaha',
          component: formPenilaianPelaksanaanPelakuUsaha,
          meta: { authRequired: true, role: ['Pemrakarsa'] },
        },

        // early warning
        {
          path: 'early-warning',
          name: 'EarlyWarning',
          redirect: '/early-warning/berusaha',
        },
        {
          path: 'early-warning/berusaha',
          name: 'EarlyWarningBerusaha',
          component: EarlyWarningBerusaha,
        },
        {
          path: 'early-warning/pemerintah',
          name: 'EarlyWarningPemerintah',
          component: EarlyWarningPemerintah,
        },
        {
          path: 'early-warning/swasta',
          name: 'EarlyWarningSwasta',
          component: EarlyWarningSwasta,
        },

        // pemutakhiran
        {
          path: 'habis-masa-berlaku',
          name: 'HabisMasaBerlaku',
          component: HabisMasaBerlaku,
        },
        {
          path: 'perubahan',
          name: 'Perubahan',
          component: Perubahan,
        },
        {
          path: 'pembatalan',
          name: 'Pembatalan',
          component: Pembatalan,
        },
        {
          path: 'pencabutan',
          name: 'Pencabutan',
          component: Pencabutan,
        },

        // perizinan
        {
          path: 'perizinan',
          name: 'PerizinanDokumenPage',
          component: PerizinanDokumenPage,
          meta: { authRequired: true, role: ['Pemrakarsa', 'Pejabat'] },
        },
        {
          path: 'perizinan/detail-perizinan/:id',
          name: 'PerizinanDetailPage',
          component: PerizinanDetailPage,
          meta: { authRequired: true, role: ['Pemrakarsa', 'Pejabat'] },
        },
        {
          path: 'nonberusaha/pemerintah',
          name: 'nonberusahaPemerintah',
          component: NonberusahaPemerintah,
          meta: { authRequired: true, role: ['Pemrakarsa', 'Pejabat'] },
        },
        {
          path: 'nonberusaha/swasta',
          name: 'nonberusahaSwasta',
          component: NonberusahaSwasta,
          meta: { authRequired: true, role: ['Pemrakarsa', 'Pejabat'] },
        },
        {
          path: 'nonberusaha/detail-perizinan/:id',
          name: 'PerizinanNonberusaha',
          component: PerizinanNonberusaha,
          meta: { authRequired: true, role: ['Pemrakarsa', 'Pejabat'] },
        },

        // masterdata
        {
          path: 'master/user',
          name: 'UserPage',
          component: UserPage,
          meta: { authRequired: true },
        },
        {
          path: 'master/jabatan',
          name: 'JabatanPage',
          component: JabatanPage,
          meta: { authRequired: true },
        },

        // setting web profile
        {
          path: '/app/web/profile',
          name: 'Profile',
          component: Profile,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/slider',
          name: 'Slider',
          component: Slider,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/about',
          name: 'About',
          component: About,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/approval',
          name: 'Perizian',
          component: Approval,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/announcement',
          name: 'Pengumuman',
          component: Announcement,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/announcement/detail/',
          name: 'Tambah Pengumuman',
          component: AnnouncementDetail,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/announcement/detail/:id',
          name: 'Edit Pengumuman',
          component: AnnouncementDetail,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/press-release',
          name: 'Siaran Pers',
          component: PressRelease,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/press-release/detail/',
          name: 'Tambah Siaran Pers',
          component: PressReleaseDetail,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/press-release/detail/:id',
          name: 'Edit Siaran Pers',
          component: PressReleaseDetail,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/report',
          name: 'Report',
          component: Report,
          meta: { authRequired: true },
        },
        {
          path: '/app/web/faq',
          name: 'FAQ',
          component: faq,
          meta: { authRequired: true },
        },

        // user
        {
          path: 'profil',
          name: 'ProfilePage',
          component: ProfilePage,
          meta: { authRequired: true, role: ['Pemrakarsa'] },
        },
        {
          path: 'panduan',
          name: 'Panduan',
          component: PanduanPage,
          meta: { authRequired: true, role: ['Pemrakarsa'] },
        },
      ],
    },
    {
      path: '/denied',
      name: 'ErrorDenied',
      component: ErrorPage403,
    },
    {
      path: '*',
      name: 'Error',
      component: ErrorPage,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const user = JSON.parse(localStorage.getItem('userPengendalian')) || {}
  const userRoles = user?.roles || (user?.role ? [user.role] : [])
  const routeRoles = to.meta?.role || []

  if (to.meta.authRequired) {
    if (userRoles.length === 0) {
      return next('/login')
    }
    if (userRoles.includes('Superuser')) {
      return next()
    }
    if (routeRoles.length > 0 && !routeRoles.some((r) => userRoles.includes(r))) {
      return next('/denied')
    }
    const centralVerifierCanViewUpt =
      isVerifikatorPusat(user) && ['RencanaAksiUpt', 'FormRencanaAksiUpt'].includes(to.name)
    if (
      to.meta.rencanaAksiScope &&
      !centralVerifierCanViewUpt &&
      !canAccessUptScope(user, to.meta.rencanaAksiScope, 'Verifikator') &&
      !canAccessUptScope(user, to.meta.rencanaAksiScope, 'Penilai')
    ) {
      return next('/denied')
    }
    if (to.meta.penilaianPelaksanaanScope && !canAccessUptScope(user, to.meta.penilaianPelaksanaanScope, 'Penilai')) {
      return next('/denied')
    }
  }
  if (to.meta.redirectIfLogin && userRoles.length > 0) {
    return next('/')
  }
  next()
})

export default router
